import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { supabase } from '@/lib/supabase';
import { validateOrdinaryPostAuthNext } from '@/lib/auth-utils';

export default function AuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [errorMsg, setErrorMsg] = useState('');
  const exchangedRef = useRef(false);

  useEffect(() => {
    const code = searchParams.get('code');
    const next = searchParams.get('next');

    if (exchangedRef.current) return;

    if (!code) {
      setErrorMsg('Thiếu mã xác thực trong đường dẫn.');
      return;
    }

    exchangedRef.current = true;

    const run = async () => {
      const { data, error } = await supabase.auth.exchangeCodeForSession(code);

      if (error) {
        setErrorMsg(error.message);
        return;
      }

      if (data.redirectType === 'recovery') {
        navigate('/login', { replace: true });
        return;
      }

      navigate(validateOrdinaryPostAuthNext(next), { replace: true });
    };

    run();
  }, [searchParams, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background-50 px-4">
      <div className="flex w-full max-w-sm flex-col items-center gap-4 text-center">
        {errorMsg ? (
          <>
            <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-accent-100 text-accent-700">
              <i className="ri-error-warning-line text-2xl" />
            </div>
            <p className="text-sm text-foreground-700">{errorMsg}</p>
            <button
              type="button"
              onClick={() => navigate('/login', { replace: true })}
              className="whitespace-nowrap rounded-lg bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition hover:bg-primary-600"
            >
              Quay lại đăng nhập
            </button>
          </>
        ) : (
          <>
            <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary-500 border-t-transparent" />
            <p className="text-sm text-foreground-500">Đang xác thực...</p>
          </>
        )}
      </div>
    </div>
  );
}